import IcCheckOn from '@/assets/svg/ic-check-on.svg?inline'
import IcMinus from '@/assets/svg/ic-minus.svg?inline'

export default {
  name: 'Checkbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    /**
     * Обзятальный если modelValue и trueVAlue и/или value являются объектами
     */
    fieldId: { type: String | Number },
    value: { type: String | Object },
    modelValue: { default: false },
    label: { type: String},
    trueValue: { default: true },
    falseValue: { default: false },
    indeterminate: { type: Boolean, default: false }
  },
  components: {
    IcCheckOn,
    IcMinus
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        if (typeof this.value === 'object') {
          return this.modelValue.find(item => this.compareOptions(item, this.value)) !== undefined
        }
        return this.modelValue.includes(this.value)
      }
      if (typeof this.modelValue === 'object' && typeof this.trueValue === 'object') {
        return this.compareOptions(this.modelValue, this.trueValue)
      }
      return this.modelValue === this.trueValue
    }
  },
  mounted() {
    this.$refs.input.indeterminate = this.indeterminate
  },
  watch: {
    indeterminate(val) {
      this.$refs.input.indeterminate = val
    }
  },
  methods: {
    compareOptions(first, second) {
      /**
       * Лучше не строгое равество
       */
      return first && second && first[this.fieldId] == second[this.fieldId]
    },
    updateInput(event) {
      let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          let index = -1
          if (typeof this.value === 'object') {
            index = newValue.findIndex(item => this.compareOptions(item, this.value))
          } else {
            index = newValue.indexOf(this.value)
          }
          newValue.splice(index, 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
}

